module.exports = __webpack_public_path__ + "img/alipay_scan.d2915c31.png";